export default "__VITE_ASSET__aKacsmrV__"